export const VERIFY_PAYMENT_START = 'VERIFY_PAYMENT_START'
